/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
// CSS
import "../../../../css/LengthWeightDisableBtn.css";

let $ = window.$;

class LengthWeightDisableBtn extends React.Component {
  handleClick(e) {
    $(".outOfStockForm_wrap")
      .finish()
      .fadeIn();
  }
  render() {
    return (
      <a
        className="notAvailable blockBtn border-grey smaller hidden"
        onClick={e => this.handleClick(e)}
      >
        <span className="notAvailable">{this.props.name}</span>
      </a>
    );
  }
}

export default LengthWeightDisableBtn;
